var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import MessageService from "../api/MessageService";
import MessageItem from "../components/newMassage/MessageItem.vue";
import WarnModal from '../components/main/warnComponents/WarnModal';
import moment from 'moment';
var initFormData = {
    s_time: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    e_time: moment().format('YYYY-MM-DD'),
    msg_type: '',
    status: '',
    keyword: '',
};
var Message = (function (_super) {
    __extends(Message, _super);
    function Message() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messages = [];
        _this.tableHeight = "0";
        _this.total = 0;
        _this.formData = __assign({}, initFormData);
        _this.typeList = [
            { name: '全部', value: -1 },
            { name: '业务消息', value: 1 },
            { name: '预警消息', value: 2 },
            { name: '报价消息', value: 3 },
            { name: '客户消息', value: 4 },
            { name: '系统消息', value: 5 },
        ];
        _this.statusList = [
            { name: '全部', value: -1 },
            { name: '已读', value: 1 },
            { name: '未读', value: 0 },
        ];
        return _this;
    }
    Message.prototype.created = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = (_this.$el.parentElement.clientHeight - 130) + "px";
            }
        }, 300);
        this.service = MessageService.getInstance();
    };
    Message.prototype.mounted = function () {
        if (this.defaultFormData) {
            this.formData = Object.assign(this.formData, this.defaultFormData);
        }
        this.getMsg();
    };
    Message.prototype.getMsg = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getMessage(Object.assign({}, this.formData, pager)).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.total = res.data.total;
            _this.messages = data;
            _this.messages.map(function (item) {
                item.src = "/static/image/business_notice_icon.png";
                item.type_text = '业务通知';
            });
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    Message.prototype.pageChange = function (pager) {
        this.getMsg();
    };
    Message.prototype.toWarnDetail = function (row) {
        this.$refs.WarnModal.showWarnModal(row.notice_params.warning_type, '1', row.notice_params.warning_id);
    };
    Message.prototype.search = function () {
        this.$refs.pagination && this.$refs.pagination.clear();
        this.getMsg();
    };
    Message.prototype.reset = function () {
        this.formData = __assign({}, initFormData);
    };
    Message = __decorate([
        Component({
            components: {
                MessageItem: MessageItem,
                WarnModal: WarnModal
            }
        })
    ], Message);
    return Message;
}(Vue));
export default Message;
